(function() {
  "use strict";

  angular.module("sempraWebapp").constant("csTranslations", {
    MESSAGE:"Zpráva",
    ERROR_TITLE:"Chyba",
    ERROR_MESSAGE:"Při spuštění operace došlo k chybě.",
    ERROR_LOGIN:"Během přihlášení došlo k chybě. E-mailová adresa není platná",
    ERROR_LOGIN_ROLE:"Role pro aktuální verzi aplikace není platná",
    OK:"OK",
    CANCEL:"Zrušit",
    YES:"Ano",
    NO:"Ne",
    FROM:"Od ",
    TO:"Do",
    DELETE:"Vymazat, odstranit",
    SIGN_OUT:"Odhlásit",
    NAME:"Jméno",
    DATE:"Datum",
    PIECES:"Kusů",
    HOURS:"Hodiny",
    DAYS:"Dnů",
    MONTH:"Měsíc",
    MONTHS:"Měsíce",
    YEAR:"Rok",
    BOX:"Box",
    SEARCH:"Hledat",
    ALL_USERS:"Všichni uživatelé",
    ARE_YOU_SURE:"Jste si jisti?",
    BACK:"Zpět",
    AMOUNT:"Množství",
    DESCRIPTION:"Popis",
    FORGOT_PASSWORD_ERROR_MSG:"Něco se pokazilo. Zkontrolujte prosím svou e-mailovou adresu a zkuste to znovu",
    REQUIRED_FIELD:"Pole je povinné",
    LOGOUT_TITLE:"Opravdu se chcete odhlásit?",
    LOGOUT_MSG:"Všechny neuložené údaje budou ztraceny",
    ACTIVATION_ACCOUNT:"Úspěšně jste aktivovali svůj účet",
    UNKNOWN_ERRROR_NOTIFICATION:"Došlo k neznámé chybě",
    CONTINUE:"Pokračovat",
    DATA_NOT_AVAILABLE:"Data nejsou k dispozici",
    SELECT:"Vybrat",
    SELECT_CURRENCY:"Vybrat měnu",
    UPLOAD:"Nahrát",
    PHONE:"Telefon",
    WEBSITE:"Webová stránka",
    WORKING_HOURS:"Otevírací doba",
    INSERT:"Vložit",
    TEXT:"Text",
    CREATED:"Vytvořeno",
    VALID_UNTIL:"Platné do",
    SAVE:"Uložit",
    TOKENS:"Žetony ",
    DELETE_COMPANY_HISTORY:"Odstranit historii společnosti?",
    DELETE_COMPANY_HISTORY_MESSAGE:"VAROVÁNÍ: Po stisknutí tohoto tlačítka budou všechny transakce vaší myčky nenávratně smazány! Tato data nelze po smazání obnovit.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Jste si jisti, že chcete trvale smazat všechna data transakcí?",
    HISTORY_SUCCESSFULY_DELETED:"History successfuly deleted",
    HELP:"Pomoc",
    VALUE:"Hodnota",
    ACTIVATING_ACCOUNT_ERROR:"Při aktivaci účtu R2W došlo k problému. Zkuste to znovu a pokud problém přetrvává, kontaktujte naši podporu na adrese support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Vítejte v Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Vítejté v R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Zadejte své nové heslo a potvrďte jej, abyste aktivovali účet R2W. Po úspěšné aktiaci se automaticky přihlásíte do aplikace",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Uživatelské nastavení můžete později změnit v aplikaci",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:" Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:"R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Zadejte prosím své nové heslo a potvrďte jej, aby bylo možné resetovat staré heslo. Po úspěšné operaci budete automaticky přihlášeni do aplikace",
    RESET_PASSWORD_WELCOME_MSG_3:"Svá uživatelská nastavení můžete později v aplikaci změnit",
    ENTER_NEW_PASSWORD:"Zadejte nové heslo",
    REPEAT_NEW_PASSWORD:"Opakujte nové heslo",
    PASSWORD_MIN_LENGTH:"Heslo musí mít alespoň 8 znaků",
    PASSWORD_MAX_LENGHT:"Heslo musí mít délku menší než 32 znaků",
    PASSWORD_PATTERN:"Heslo musí obsahovat alespoň jedno velké písmeno a jedno malé písmeno",
    PASSWORD_MATCH:"Hesla neodpovídají",
    ACTIVATE:"Aktivovat",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Úspěšně jste podali žádost. Zkontrolujte prosím svůj e-mail, zda jste obdrželi potvrzující zprávu",
    VALIDATION_REQUIRED:"Povinné pole",
    VALIDATION_EMAIL:"Neplatná emailová adresa",
    VALIDATION_INTEGER_NUMBER:"Zadejte celé číslo",
    VALIDATION_HOURS_VALUE:"Hodnota musí být mezi 0-23",
    VALIDATION_MINUTES_VALUE:"Hodnota musí být mezi 0-59",
    VALIDATION_NOT_A_DATE:"Hodnota není datum",
    VALIDATION_FROM:"Od data většího než ",
    VALIDATION_TO:"K datu méně než ",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Tento záznam již existuje v databázi",
    PASSWORD_VALIDATION_PATTERN_NEW:"Musí existovat alespoň jedna číslice a jedno velké písmeno. Mezery nejsou povoleny",
    VALIDATION_PERCENT_VALUE:"Hodnota musí být mezi 1-999",
    NUMBERS_ONLY_100:"Number up to 100",
    NUMBERS_ONLY_1000:"Number up to 1000",
    POSITIVE_NUMBERS_ONLY:"Only positive number",
    GRID_PAGER_PAGE:"Stránka",
    GRID_PAGER_ROWS_PER_PAGE:"Řádků na stránku",
    GRID_PAGER_PAGE_OF:"z",
    BREAD_CRUMBS_HOME:"Domu",
    BREAD_CRUMBS_DASHBOARD_TECH:"Technologie přístrojové desky",
    BREAD_CRUMBS_DETAILS:"Detaily",
    BREAD_CRUMBS_SETTINGS:"Nastavení",
    BREAD_CRUMBS_WORKING_HOURS:"Pracovní doba",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Celkový denní peněžní report",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Průměrný hodinový peněžní report",
    BREAD_CRUMBS_NEW_USER_GROUP:"Vytvořit uživatelskou skupinu",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Upravit uživatelskou skupinu",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Vytvořit šablonu kampaně",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Upravit šablonu kampaně ",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Vytvořit kampaň",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Upravit kampaň",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Periodické shrnutí",
    LOGIN:"Přihlásit",
    EMAIL:"E-mail",
    PASSWORD:"Heslo",
    LANGUAGE:"Jazyk",
    FORGOT_PASSWORD:"Zapomenuté heslo?",
    SUBMIT:"Předložit",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Počet nevyřízených alarmů:",
    HEADER_VIEW_ALL_ALARMS:"Zobrazit všechny alarmy ...",
    HEADER_MY_ACCOUNT:"Můj účet",
    HEADER_ACCOUNT_MANAGEMENT:"Zpráva účtu",
    ACCOUNT_ALREADY_EXIST:"Emailová adresa je již použita",
    NEWSLETTER_CONFIRMATION:"Odeslat e-mailové upozornění pro stav poplachů",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Denní finanční přehled",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Technologie přístrojové desky",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Přístrojová deska",
    ASIDE_MENU_ALARMS:"Zprávy",
    ASIDE_MENU_FACILITIES:"Vybavení",
    ASIDE_MENU_REPORTS:"Reporty",
    ASIDE_MENU_REPORT:"Vybraný přehled",
    ASIDE_MENU_LOYALTY:"Věrnost",
    ASIDE_MENU_USER_GROUPS:"Uživatelské skupiny",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodické shrnutí",
    ASIDE_MENU_MANAGING_TOKENS:"Správa žetonů",
    ASIDE_MENU_NEWS:"Zprávy",
    DAILY_FINANCES_TOTAL_MONEY:"Celkem peněz",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Celkem peněz za veškeré vybavení",
    DAILY_FINANCES_TOTAL_COINS:"Celkově použité kovové tokeny",
    DAILY_FINANCES_DOWNLOAD_CSV:"Nahrát CSV",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Hotovost",
    DAILY_FINANCES_CHANGER:"Hotovost ve měniči",
    DAILY_FINANCES_COINS:"Žetony/Eurokey",
    REPORTS_FILTER:"Filtr",
    REPORTS_TYPE_OF_REPORT:"Druh reportu",
    REPORTS_CHOOSE_FACILITY:"Vyber zařízení",
    REPORTS_PERIOD_1:"Období 1 -",
    REPORTS_PERIOD_2:"Období 2 -",
    MONEY_BY_DATE_REPORT:"Peníze celkem podle data",
    R2W_BY_DATE_REPORT:"Celkem online platby podle data",
    COINS_BY_DATE_REPORT:"Celkem platby žetony podle data",
    AVG_MONEY_BY_HOUR_REPORT:"Průměrně peněz za hodinu",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Průměrně peněz za den v týdnu",
    AVG_MONEY_BY_BOX_REPORT:"Tržby podle přístroje",
    COMPARE_PERIODS_REPORT:"Srovnávací zpráva zařízení",
    TOTAL_USERS_BY_GROUP:"Počet uživatelů celkem podle skupin",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"uživatelé",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"návštěv",
    VISITS_COUNT_REPORT:"Počet uživatelů na počet návštěv",
    LOYALTY_PER_DAY_REPORT:"Poskytnuté místní R2W žetony za den",
    LOYALTY_PER_PAYMENT_METHOD:"Poskytnté místní žetony dle platební metody",
    VISITS:"Návštěvy",
    VISIT:"Návštěva",
    TOTAL_SPENT_MONEY:"Celkem použito peněz",
    MONEY:"Peníze",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Celkem použito peněz za období",
    DOWNLOAD_CSV:"Nahrát CSV",
    TOTAL_SPENT_COINS:"Celkem použito žetonů",
    TOTAL_USERS:"Celkem uživatelů",
    TOTAL_CREDIT_GIVEN:"Celkový poskytnutý kredit",
    EUROKEY_BY_DATE_REPORT:"Celkové platby Eurokey podle data",
    TOTAL_SPENT_EUROKEY:"Celkem vynaloženon ",
    SELECT_TYPE_OF_REPORT:"Je třeba vybrat typ přehledu :)",
    NUMBER_OF_VISITS_TITLE:"Počet návštěv",
    NUMBER_OF_USERS_TITLE:"Počet uživatelů",
    PIECES_TITLE:"Kousky",
    TOTAL_VISITS:"Celkový počet návštěv",
    TOKENS_TITLE:"žetony",
    SEARCH_USERS_NO_RESULTS:"Pro daný hledaný výraz nenalezeny žádní uživatelé",
    SEARCH_USERS:"Hledání uživatelů",
    SEARCH_TELEPHONES:"Hledání uživatelů dle mobilního čísla",
    ADD_USER_TO_GROUP:"Přidat uživatele do skupiny",
    REMOVE_USER_FROM_GROUP:"Odstranit uživatele ze skupiny",
    USER_GROUP_NAME_REQUIRED:"Je vyžadován název skupiny uživatelů",
    USER_GROUP_NAME:"Název skupiny uživatelů",
    USER_GROUPS_OVERVIEW:"Přehled skupin uživatelů",
    USER_COUNT:"Počet uživatelů",
    NEW_USER_GROUP:"Vytvořit novou uživatelskou skupinu",
    DELETE_USER_GROUP:"Odstranit uživatelskou skupinu",
    UPDATE_USER_GROUP:"Upravit skupinu uživatelů",
    DELETE_USER_GROUP_ERROR:"Při odstraňování vybrané skupiny uživatelů došlo k chybě. Zkuste to prosím znovu nebo kontaktujte podporu ...",
    CONFIRM_DELETE_USER_GROUP:"Opravdu chcete smazat vybranou skupinu uživatelů?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Věrnostní akce, ke kterým byla přiřazena smazaná skupina, již nebudou použiváné.",
    GROUP_NAME_MAX_LENGTH:"Název skupiny musí mít délku menší než 255 znaků",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Uživatel je již v této skupině",
    MISSING_USER:"Missing user(en)",
    USER_NOT_ON_LIST:"User is not in the active users list. Check if the email address is valid and try again(en).",
    UPLOAD_USER_GROUP:"Upload user group list from *.csv file",
    UKNOWN_USERS:"List of uknown users",
    CAMPAIGN_TEMPLATE_RULE:"Pravidlo šablony",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Při pokusu o odstranění šablony kampaně došlo k chybě. Zkuste to prosím znovu nebo kontaktujte podporu …",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Opravdu chcete vybranou šablonu kampaně smazat",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Opravdu chcete vybranou šablonu kampaně smazat",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Přehled šablon kampaní",
    DELETE_CAMPAIGN_TEMPLATE:"Smazat šablonu kampaně",
    UPDATE_CAMPAIGN_TEMPLATE:"Upravit šablonu kampaně",
    CREATE_CAMPAIGN_TEMPLATE:"Vytvořte novou šablonu kampaně",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Je požadován název šablony kampaně",
    CAMPAIGN_TEMPLATE_NAME:"Název šablony kampaně",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Povinné pole",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"dát %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"více času",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Nejprve prosím vyberte typ. Mycí boxy nebo malé stroje.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Smazat pravidlo šablony",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"hodiny",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuty",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nové pravidlo podle počtu návštěv",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nové pravidlo založené na použitých žetonech",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nové pravidlo podle dnů v týdnu",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Přidat nové pravidlo šablony",
    CAMPAIGN_TEMPLATE_RULE_1:"Každý",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Každý",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"Žetony vynaložené za méně než",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"návštěv za méně než",
    CAMPAIGN_TEMPLATE_RULE_3:"dny",
    CAMPAIGN_TEMPLATE_RULE_4:"Žetony",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Seznam pravidel je prázdný.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum nemůže být v minulosti",
    DELETE_CAMPAIGN_ERROR:"Při pokusu o smazání kampaně došlo k chybě. Zkuste to prosím znovu nebo kontaktujte podporu ...",
    CONFIRM_DELETE_CAMPAIGN:"Opravdu chcete smazat vybranou kampaň?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W není odpovědný za uživatelskou zkušenost způsobenou touto akcí.",
    CAMPAIGNS_OVERVIEW:"Přehled kampaní",
    DELETE_CAMPAIGN:"Smazet kampaň",
    UPDATE_CAMPAIGN:"Upravit kampaň",
    CREATE_CAMPAIGN:"Vytvořit novou kampaň",
    CAMPAIGN_ACTIVE:"Aktivní",
    CAMPAIGN_TEMPLATE:"Šablona",
    CAMPAIGN_GROUPS:"Skupiny",
    CAMPAIGN_ALL_USERS:"Všechny uživatele",
    CAMPAIGN_NAME:"Název kampaňe",
    CAMPAIGN_NAME_REQUIRED:"Povinný",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Počet uživatelů blízko denního prahu",
    MESSAGE_TO_USERS:"Zpráva pro filtrované uživatele",
    SEND_MESSAGE:"Odeslat zprávu",
    THRESHOLD:"Práh",
    TYPE:"Druh ",
    TOTAL_MONEY_SPENT:"Celkové peníze vynaložené v kampani",
    NUMBER_OF_VISITS:"Počet návštěv v kampani",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Zpráva musí mít délku nejméně 10 znaků",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Zpráva musí mít délku menší než 350 znaků",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Text zprávy je vyžadován",
    TECHNOLOGY:"Technologie ",
    TAP_WATER:"Voda z vodovodu",
    REVERSE_OSMOSIS:"Reverzní osmóza",
    SOFTENED_WATER:"Změkčená voda",
    DOSER:"Dávkovač",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Poslední synchronizace",
    NO_OF_CURRENT_ALARMS:"Počet aktuálních alarmů",
    NO_OF_CURRENT_WARNINGS:"Počet aktuálních varování",
    WEATHER:"Počasí",
    BOXES_WORK_HOURS_COUNTERS:"Pracovní doba boxů",
    BOX_TOTAL_HOURS:"Celková pracovní doba",
    BOX_SERVICE_HOURS:"Celková pracovní doba (servis)",
    BOX_COUNTER_HOURS:"hodiny",
    ALARMS_AND_WARNINGS:"Alarmy a varování",
    FILTER_AND_BOILER:"Filtr a bojler",
    FILTER_TOTAL_DAYS:"Filtr pracovní dny",
    BOILER_TOTAL_DAYS:"Bojler pracovní dny",
    DAYS_UNIT:"dny",
    SOFTENER:"Změkčovač",
    MANUAL_COLD_DRAIN:"Ruční studený odtok",
    EL_COLD:"El. studený",
    DRAIN:"odtok",
    TAP:"Kohoutek",
    WASTE:"Odpad",
    OSMOSIS:"Osmóza",
    DEMI_WATER:"Demineralizovaná voda",
    EL_RINSE:"El. m. oplach",
    BOILER:"Bojler",
    EL_WAX:"El. M. vosk",
    FLOOR_HEATING:"Podlahové topení",
    DOSER_TANK:"Dávkovací nádrž",
    EL_WASH:"El. M. mytí",
    DETERGENT:"Saponát",
    VIBRATOR:"Vibrátor",
    UPDATE_FACILITY_SETTINGS:"Aktualizovat nastavení",
    GENERAL_SETTINGS:"Obecné nastavení",
    LIGHTS:"Světla",
    GROUPS:"Skupiny",
    ANTI_FREEZE:"Nemrznoucí směs",
    AUTO:"Auto",
    MANUAL:"Návod",
    ON:"Zapnuto",
    OFF:"Vypnuto",
    TEMPERATURE:"Teplota",
    UPDATE_DEVICE:"Aktualizace nastavení zařízení",
    BOX_CLEAN_HOURS:"Počitadla čítačů (hodiny)",
    GROUP_COUNTERS:"Skupinové čítače",
    RESET:"resetovat",
    CASH_COUNT:"Počet mincí",
    COINS_COUNT:"Počet žetonů",
    EUROKEY_COUNT:"Počet Eurokeyů",
    DOSER_WORK:"Dávkovač provozní doba (sec)",
    DOSER_PAUSE:"Doba pozastavení dávkování (sec)",
    DELAY_BFV:"BFV zpoždění (ms)",
    DELAY_6M1:"6M1 zpoždění (ms)",
    DELAY_LPS:"LPS zpoždění (ms)",
    RESET_CASH_COUNT_ALL:"Resetovat všechny počitadla mincí",
    RESET_COINS_COUNT_ALL:"Resetovat všechny počítadla žetonů",
    RESET_EUROKEY_COUNT_ALL:"Resetovat všechny počítadla Eurokey",
    FACILITY_DETAILS:"Podrobnosti o zařízení",
    FACILITY_NAME:"Název zařízení",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Úspěšně jste nahráli obrázek",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Úspěšně jste aktualizovali data",
    CONNECTED:"Připojeno",
    DISCONNECTED:"Odpojeno",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Filtr zpráv",
    FACILITY:"Zařízení",
    APPLY:"Použít",
    TIME:"Čas",
    LOCATION:"Umístění",
    ACKNOWLEDGED:"Potvrzeno",
    FILTERED_MESSAGES:"Filtrované zprávy",
    ACK:"Potvrzeno",
    NOT_ACK:"Nepotvrzeno",
    ALL:"Vše ",
    ALL_FACILITIES:"Všechná zařízení",
    ENTER_DATE_PLACEHOLDER:"Vložit datum",
    OP_NESTANAK_NAPONA:"Chybějící napětí na indikátoru fáze 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Jistič vysokotlakého čerpadal klesl",
    OP_UPR_NAPON_24VAC_GRE:"Chybí 24 VAC - jistič 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Nádrž na čistou vodu je prázdná",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Síťový jištič čerpadla klesl",
    OP_MIN_NIVO_OMEKS_VODE:"Nádrž na změkčenou vodu je prázdná",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Jistič čerpadla změkčené vody klesl",
    OP_MIN_NIVO_DEMIN_VODE:"Nádrž na osmózní vodu je prázdná",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Jistič čerpadla osmózní vody klesl",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Jistič čerpadla na výrobu osmózní vody klesl",
    OP_BOJLER_GRESKA_MZS:"Chyba ohřívače vody",
    OP_CRPKA_PRASKA_GRE_MZS:"Jistič čerpadla horké vody klesl",
    OP_DOZATOR_PRASKA_GRE_MZS:"Jistič motoru dávkovače prášku klesl",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Jistič vibrátoru dávkovače prášku klesl",
    OP_MIN_PRASAK_TON_ALARM:"Nádoba na míchání prášku je prázdná",
    OP_USIS_KOV_TURBINA_GRESKA:"Jistič vaakuového vysavače na mince klesl",
    OP_FILTER_VODE_ZACEPLJEN:"Vodní filtr je zablokován",
    OP_VISKTL_RESET_SATI_RADA:"Servis vysokotlakého čerpadla",
    OPW_VISKTL_RESET_SATI_RADA:"Servis vysokotlakého čerpadla",
    OP_FILTER_DANI_RADA:"Porucha vodního filtru",
    OP_BOJLER_DANI_RADA:"Chyba ohřívače vody",
    OPW_ALARM_VISOKOTL_PUMPA:"Výstraha vysokotlakého čerpadla",
    OPW_ALARM_FILTER_SERVIS:"Výstraha servisu filtru",
    OPW_ALARM_BOJLER_SERVIS:"Výstraha servisu bojleru",
    HAS_MEMBERS:"Vybraná skupina má členy a nelze ji odstranit. Členové musí být nejprve smazáni.",
    PERIODIC_SUMMARY_FOR:"Periodické souhrnné hlášení za",
    PERIODIC_SUMMARY_REPORTS:"Periodické souhrnné zprávy",
    DATE_RANGE:"Časové období",
    FINANCIAL_REPORT:"Finanční zpráva",
    GROSS_INCOME:"Hrubý příjem",
    GROSS_INCOME_SUM:"Výše hrubého příjmu",
    COMMISSION_FEE:"Poplatek za zprostředkování",
    NET_INCOME:"Čistý příjem (pro fakturaci)",
    COMMISSION_FEE_DETAILS:"Poplatek zahrnuje bankovní / PayPal poplatky anebo provize poskytovatele SMS služeb.",
    LOYALTY_CREDITS_REPORT:"Mistní R2W výkaz o žetonech",
    LOYALTY_GIVEN:"Dané lokální R2E žetony",
    LOYALTY_USED:"Použité lokální R2W žetony",
    LOYALTY_SOLD:"Prodáno lokálních R2W žetonů",
    LOYALTY_TOTAL:"Celkem",
    LOYALTY_CURRENT_MONTH:"Aktuální měsíc",
    SOMETHING_WENT_WRONG:"Ooooops",
    MISSING_PAGE:"Promiňte. Tuto stránku jsme nenalezli",
    TRY_AGAIN:"Zkuste to znovu",
    DEFAULT_ERROR_NAME:"Došlo k neznámé chybě",
    DEFAULT_ERROR_DESCRIPTION:"Prosím, zkuste to znovu",
    MY_ACCOUNT_DETAILS:"Detaily mého účtu",
    SAVE_CHANGES:"Uložit změny",
    USERNAME:"Uživatelské jméno",
    FIRST_NAME:"Jméno",
    LAST_NAME:"Přímení",
    USER_ROLE:"Role uživatele",
    OLD_PASSWORD:"Staré heslo",
    NEW_PASSWORD:"Nové heslo",
    OLD_PASSWORD_REQUIRED:"Je vyžadováno staré heslo",
    NEW_PASSWORD_REQUIRED:"Je vyžadováno nové heslo",
    NEW_PASSWORD_REPEAT:"Je vyžadováno opakování nového hesla",
    NEW_PASSWORD_NOT_MATCH:"Staré a nové heslo neodpovídají",
    PASSWORD_DIFFERENT_VALIDATION:"Nové heslo musí být jiné než staré",
    PASSWORD_MIN_CHAR:"Vaše heslo musí mít délku alespoň 8 znaků",
    PASSWORD_MAX_CHAR:"Vaše heslo musí mít délku maximálně 32 znaků",
    PASSWORD_PATTERN_VALIDATION:"Heslo musí obsahovat alespoň jedno číslo",
    ACCOUNT_MANAGEMENT:"Správce účtu",
    NOT_ACTIVE:"Neaktivní",
    ASSIGN_ROLE:"Přiřaďte roli",
    UPDATE:"Aktualizace",
    ADD_NEW_ACCOUNT:"Přidat nový účet",
    EMAIL_REQUIRED:"Je vyžadována e-mailová adresa",
    EMAIL_NOT_VALID:"E-mailová adresa není platná",
    ADD_NEW_USER_TEXT:"E-mail s aktivačním odkazem bude odeslán na poskytnutou e-mailovou adresu.",
    UPDATE_USER_NOTIFICATION:"Úspěšně jste aktualizovali své informace",
    CHANGED_PASSWORD_NOTIFICATION:"Úspěšně jste změnili heslo",
    UPDATE_USER_GROUP_NOTIFICATION:"Úspěšně jste aktualizovali název skupiny uživatelů",
    CREATE_USER_GROUP_NOTIFICATION:"Úspěšně jste vytvořili skupinu",
    DETELE_USER_GROUP_NOTIFICATION:"Úspěšně jste smazali skupinu",
    EMPTY_GROUP_LIST_MSG:"Neexistují žádné vytvořené skupiny. Začněte tím, že vytvoříte jednu",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Úspěšně jste smazali uživatele ze skupiny",
    ADD_USER_TO_GROUP_NOTIFICATION:"Úspěšně jste přidali uživatele do skupiny",
    ADD_USER_NOTIFICATION:"Úspěšně jste přidali nového uživatele",
    DELETE_USER_NOTIFICATION:"Úspěšně jste smazali uživatele",
    RESEND_USER_VERIFICATION_EMAIL:"Úspěšně jste znovu odeslali ověřovací e-mail",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Chcete-li vytvořit skupinu uživatelů",
    DELETE_USER:"Odstranit uživatele",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Opravdu chcete smazat uživatele ze skupiny uživatelů?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Vážený uživateli R2W",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Věrnostní pravidlo podle počtu návštěv",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Věrnostní pravidlo pro množství vynakládaných žetonů",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Věrnostní pravidlo za den v týdnu",
    REMOVE_CAMPAIGN_RULE_TITLE:"Odstranění pravidla kampaně",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Opravdu chcete zrušit pravidlo kampaně?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Úspěšně jste vytvořili novou kampaň",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Úspěšně jste aktivovali kampaň",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Neexistují žádné vytvořené kampaně. Začněte tím, že vytvoříte jednu",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Úspěšně jste odeslali zprávu",
    COMPANY_ACCOUNTS:"Firemní účty",
    BUSSINESS_INVOICES_LIST:"My B2B faktury",
    LOCALE_TOKEN:"Místní token",
    R2W:"Globální token",
    START_MONTH:"Počáteční měsíc",
    END_MONTH:"Měsíc konce",
    TOKEN_TYPE:"Typ tokenu",
    TOKEN_NUMBER:"Číslo tokenu",
    NOTHING_TO_DISPLAY:"* Nic k zobrazení",
    CREATE_INVOICE:"Vytvoření faktury",
    INVOICE:"Faktura",
    INVOICES:"Faktury",
    EDIT_INVOICE:"Upravit fakturu",
    UPDATE_INVOICE_NOTIFICATION:"Úspěšně jste aktualizovali fakturu do stavu čekajícího",
    CURRENT_CHARGES:"Poplatky za běžné období",
    PAYMENTS_ON_HOLD:"Rozpracované faktury",
    FOR_INVOICING:"Pro fakturaci",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Chystáte se zrušit fakturu",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Opravdu chcete tuto fakturu zrušit?",
    INVOICING_NOTIFICATION_HEADER:"Chystáte se fakturovat",
    INVOICING_NOTIFICATION_TEXT:"Opravdu chcete zaslat fakturu?",
    SENT_INVOICE_NOTIFICATION:"Úspěšně jste zaslali fakturu",
    CANCELED_INVOICE_NOTIFICATION:"Úspěšně jste zrušili fakturu",
    INVOICE_DESCRIPTION_TEXT:"Faktura za",
    INVOICE_STATE:"Stav fakturace",
    INVOICE_NUMBER:"Číslo faktury",
    INVOICE_TOTAL:"Celkem",
    SELECT_YEAR:"Vybrat rok",
    DOWNLOAD:"Stáhnout PDF",
    INVOICE_NUMBER_HEADER:"Chystáte se odeslat fakturu s číslem",
    INVOICE_PAYMENT_CONFIRMATION:"Chystáte se potvrdit platbu",
    INSERT_INVOICE_NUMBER:"Vložte číslo faktury",
    INVOICED_WARNING:"E-mail nebyl odeslán. Prosím, čekejte ...",
    SEND_INVOICE:"Poslat",
    INVOICE_ALL:"Vše",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Do R2W",
    PAYMENT_REQUEST:"Výzva k úhradě",
    PAYMENT_REQUEST_STATE:"Stav žádosti o platbu",
    PAYMENT_REQUEST_NUMBER:"Číslo žádosti o platbu",
    FOR_PAYMENT_REQUEST:"Pro žádost o platbu",
    PAYMENT_REQUEST_ON_HOLD:"Žádost o platbu při zpracování",
    DOWNLOAD_INVOICE:"Stažení faktury",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Klepněte pro možnosti stahování",
    B2B_SPEC:"B2B Specifikace",
    B2C_SPEC:"B2C Specifikace",
    DOWNLOAD_PAYMENT_REQUEST:"Stáhnout žádost o platbu",
    LOYALTY_PREVIEW:"Náhled do věrnostního programu",
    ACTIVATED:"Aktivováno",
    RUNNING:"Běžící",
    NOT_ACTIVATED:"Neaktivní",
    FINISHED:"Ukončeno",
    DEPRECATED:"Zastaralé",
    UPCOMING:"Nadcházející",
    NONE:"Žádný",
    STARTED:"zahájena",
    ENDS:"Končí",
    DEDICATED:"Věnované",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Chystáte se aktivovat",
    CAMPAIGN:"kampaň",
    SEND_MESSAGE_NOTIFICATION:"Chystáte se odeslat zprávu vybraným skupinám uživatelů",
    DIVISIBLE_TO_NUMBER:"Číslo by mělo být dělitelné ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Typ zařízení",
    LISTENER:"Malé stroje",
    BRIDGE:"Mycí boxy",
    WASH_BOXES:"Mycí boxy",
    VACUUMS:"Vysavače",
    SAVE_NEWS:"Uložit zprávy",
    CREATE_NEW_NEWS:"Vytvořte nové zprávy",
    HISTORY_OF_ALL_NEWS:"Historie všech zpráv",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Zadejte název zařízení",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Přidat další zařízení",
    NEWS_TEXT:"Text zprávy",
    NEWS_TITLE:"Název zprávy",
    DELETE_NEWS_CONFIRMATION:"Chystáte se smazat zprávy",
    NEWS_DELETE_NOTIFICATION:"Úspěšně jste smazali zprávy",
    NEWS_SAVE_NOTIFICATION:"Úspěšně jste uložili zprávy",
    NEWS_CREATION_DATE:"Datum vzniku",
    NO_TITLE:"Bez názvu",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Text zprávy musí obsahovat méně než 255 znaků",
    NEWS_TEXT_REQUIRED_VALIDATION:"Text zprávy je vyžadován",
    NEWS_TITLE_REQUIRED_VALIDATION:"Je vyžadován název zprávy",
    DEACTIVATE:"Deaktivujte",
    ASIDE_MENU_LOCAL_TOKENS:"Lokální žetony",
    CREATE_NEW_LOCAL_TOKENS:"Vydat nové lokální žetony?",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Zadejte e-mailovou adresu zákazníka a množství místních žetonů, které chcete vystavit zákazníkovi",
    CREATE_TOKENS:"Vydání žetonů",
    MINIMUM_ONE_TOKEN:"Hodnota musí být větší než 0",
    CUSTOMER_EMAIL:"Zákaznický e-mail",
    AMOUNT_OF_TOKENS:"Množství žetonů",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Úspěšné vydání místních žetonů",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Při vydávání místních žetonů došlo k chybě. Zkontrolujte prosím e-mailovou adresu zákazníka a zkuste to znovu.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Přehled vydaných místních žetonů",
    ISSUED_AT:"Vydáno v",
    ISSUED_BY:"Vydáno",
    CODE:"Použít kód",
    REDEEMED_BY:"Vykoupeno",
    REDEEMED_AT:"Vykoupeno u",
    ASIDE_MENU_VOUCHERS:"Poukazy",
    PRINT:"Tisk",
    VOUCHERS_OVERVIEW:"Přehled poukazů",
    CREATE_NEW_VOUCHERS:"Vytvořte nové poukazy",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Vytvořte novou sadu poukazů zadáním množství žetonů na jednom poukaze",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Množství žetonů na jeden poukaz",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Můžete přiřadit 1 až 100 žetonů na poukaz",
    NUMBER_OF_NEW_VOUCHERS:"Počet poukazů, který mají být vytvořeny",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Můžete si vytvořit jednen až {{size}} poukazů v jedné dávce",
    NEW_VOUCHERS_PREFIX:"Předpony kódů nové série poukazů",
    VALIDATION_VOUCHER_PREFIX:"Předpona kódu musí mít přesně 4 znaky (velká písmena a / nebo čísla)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Při vytváření nových poukazů došlo k problému. Zkuste to prosím znovu nebo kontaktujte naši podporu.",
    CREATE_VOUCHERS:"Vytvořte poukazy",
    CREATING_VOUCHERS_SUCCESS:"Nové vouchery byly úspěšně vytvořeny",
    PRINT_NEW_VOUCHERS:"Tisk poukazů",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Zadejte předponu kódu série poukazů, abyste vytiskli celou sérii poukazů. Alternativně",
    PRINT_VOUCHERS_PREFIX:"Předvolba kódu série poukazů",
    NO_VOUCHERS_FOR_PRINT:"Nebyly nalezeny žádné poukazy odpovídající dané předponě kódu pro tisk",
    PRINT_VOUCHERS:"Tisknout poukaz(y)",
    VALIDATION_VOUCHER_CODE_FILTER:"Výsledek hledání voucheru musí obsahovat velká písmena a čísla",
    FILTER_VOUCHERS_BY_CODE:"Vyhledat poukazy pomocí kódu vykoupení",
    FILTER_VOUCHERS:"Vyhledat poukaz",
    WASH_BOX:"Mycí box",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Celkově použité digitální tokeny",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Celkem nakoupené lokální žetony za den",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Celkem utracené lokální žetony za den",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Celkem vydané lokální žetony za den",
    LOCAL_TOKEN:"Lokální žetony",
    GIVEN_TOKEN:"Vydané lokální žetony",
    SOLD_TOKEN:"Prodané lokální žetony",
    SMALL_MACHINES:"Malé stroje",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:" HHanle wash box",
    CODE_PREFIX_EXIST:"Předpony kódu již existují",
    CODE_PREFIX_EXIST_TEXT:"Nelze vytvořit nový voucher s touto předponou kódu. Nastavte prosím jinou.",
    MIN_FOUR_VALIDATION:"Přesně 4 znaky",
    ALL_INFORMATION_1:"Všechny informace o",
    ALL_INFORMATION_2:"bude ztraceno",
    ASIDE_MENU_TRANSACTIONS:"Transakce",
    EXPENSES:"Výdaje",
    TOPUPS:"Zakoupené žetony",
    EXPENSES_LIST:"Seznam výdajů",
    USER_EMAIL:"Uživatelský e-mail",
    COMPANY_NAME:"Jméno společnosti",
    TOPUPS_LIST:"Seznam zakoupených symbolů",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Sériové číslo",
    SETUP_UNIT_MATERIAL_NO:"Číslo materiálu",
    SETUP_UNIT_WEBAPI_VERSION:"Verze WebApi",
    TOTAL_TURNOVER:"Obrat mycího zařízení",
    AVAILABILITY_ALL:"Dostupnost",
    AVAILIBILITY:"Dostupnost mycích boxů:",
    AVAILABILITY_VACUUMS:"Dostupnost vysavačů:",
    WASH_BOX_INFO:"Informace o mycích boxech",
    VACUUM_CLEANER_INFO:"Informace o vysavačích",
    BREAD_CRUMBS_SERVICE:"Servis",
    HOLIDAYS:"Prázdniny",
    HOLIDAY:"Dovolená",
    LIGHTS_ON:"Svetla zapnuo",
    LIGHTS_OFF:"Světla vypnuto",
    WASH_BOXES_ON:"Mycí box zapnuto",
    WASH_BOXES_OFF:"Mycí box vypnuto",
    VACUUMS_ON:"Vysasvač zapnuto",
    VACUUMS_OFF:"Vysavač vypnuto",
    TURNOVER:" Obrat",
    TURNOVER_MANUAL_WASH_UNIT:"Manuál obratu",
    STATUS_BAY_RUN_TIME:"Celková doba práce mycího boxu",
    STATUS_BAY_PROGRAM_NAME:"Název programu",
    STATUS_BAY_CREDIT:"Kredit na mycí box",
    CLOUD_KREDIT:"Cloudový kredit",
    STATUS_VACUUM_RUN_TIME:"Celková doba práce vysavače",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Služby zařízení, program mycího boxu a aktuální informace o poruchách",
    UNAVAILABLE:"Jednotka není k dispozici",
    SHOW_HIDE_TABLE:"Zobrazit/skrýt tabulku pracovní doby",
    PROGRAM_NAME:"Název programu",
    PROGRAM_OPTION:"Možnost programu",
    DEVICE:"Zařízení",
    QUANTITY:"Množství",
    PROGRAM_COUNTER:"Počítadlo programu",
    NO_NAME:"Odkaz nemá jméno",
    COUNTER_SERVICE_DATA:"Servisní informace",
    NEED_SERVICE:"Nutný servis",
    PROGRAM_DATA:"Data programu mycího boxu",
    CURRENT_FAULT_DATA:"Aktuální údaje o závadě",
    REFERENCE_DUE:"Z důvodu",
    REFERENCE_SECONDS:"Vtreřiny",
    REFERENCE_NAME:"Název dílu",
    WASHBOX_NAME:"Název micího boxu",
    FAULT_NAME:"Název poruchy",
    FAULT_NUMBER:"Číslo poruchy",
    CURRENT_FAULT_COUNT:"Aktivní poruchy",
    DEVICE_NOT_INSTALLED:"Zařízení není instalováno",
    STATUS_READY:"Stav připraven",
    STATUS_ERROR:"Chybový stav",
    CONNECTION_ERROR:"offline",
    UNKNOWN_RESET:"Chyba softwaru",
    SOFTWARE_RESET:"Chyba softwaru",
    EXTERNAL_PIN_RESET:"Chyba softwaru",
    RESTART_OR_BROWNOUT_OCCURRED:"Chyba softwaru",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Chyba hardwaru",
    COULD_NOT_SIMULATE_COIN:"Chyba hardwaru",
    ERROR_SETTING_INHIBIT_MODE:"Chyba hardwaru",
    OFFLINE_DEVICE:" Offline myčka",
    TARIFFS:"Tarify",
    DAY:"Den",
    NIGHT:"Noc",
    VOUCHER_CODE:"Kód poukazu",
    DISMISS_ALARM:"Resetovat alarm?",
    ALARM_ACTIVE:"Aktivní alarmy",
    NO_ALARM_ACTIVE:"Nejsou žádné aktivní alarmy",
    ALARM_HISTORY:"Historie upozornění",
    MANAGING_TOKENS:"Správa žetonů",
    EXPIRATION_DATE:"Datum spotřeby",
    EXTEND_TOKEN_DATE:"Prodloužit datum vypršení platnosti tokenu pro",
    DELETE_TOKENS_FOR:" Delete tokens for",
    PUMP_TYPE:"Typ čerpadla",
    TURN_OFF_DEVICE:"Stav zařízení",
    OPERATION_DATA:"Provozní údaje",
    PUMP_DATA:"Údaje čerpadla",
    PUMP_NAME:"Název čerpadla",
    POINT_NAME:"Název bodu",
    CHANGER_INCOME:"Celkový příjem měniče podle data",
    SELECTED_OPEN:"Otevřeno ve vybranou pracovní dobu",
    ALWAYS_OPEN:"Vždy otevřeno (24/7)",
    CLOSED:"Zavřeno",
    CLOSED_24:"Zavřeno 24h",
    OPENED_24:"Otevřeno 24h",
    MON:"Pondělí",
    TUE:"Úterý",
    WED:"Středa",
    THU:"Čtvrtek",
    FRI:"Pátek",
    SAT:"Sobota",
    SUN:"Neděle",
    PRICING:"Ceny",
    PRICE:"Cena",
    VALIDITY:"Platnost",
    TOKEN_PACKAGES:"balíčky žetonů",
    SINGLE_WASH:"Jednorázové mytí",
    FACILITY_WORKING_HOURS:"Nastavte pracovní dobu pro vybrané zařízení",
    WORKING_HOURS_ALWAYS_OPEN:"Vždy otevřeno",
    WORKING_HOURS_ALWAYS_CLOSE:"Uzavřeno provozovatelem",
    WORKING_HOURS_CUSTOM:"Nastavte pracovní dobu",
    KARCHER_ERROR_CODE:"Varovný chybový kód",
    KARCHER_ERROR_MESSAGE_1:"Elektrické zásuvky jsou přetížené",
    KARCHER_ERROR_MESSAGE_2:"Separátor oleje se musí vyprázdnit",
    KARCHER_ERROR_MESSAGE_4:"Vadný snímač stmívání",
    KARCHER_ERROR_MESSAGE_5:"Byl spuštěn ochranný spínač motoru na vysokotlakých čerpadlech",
    KARCHER_ERROR_MESSAGE_6:"Vadné připojení k RDS",
    KARCHER_ERROR_MESSAGE_7:"Tlakový spínač pro vzduch na kompresoru nehlásí žádný",
    KARCHER_ERROR_MESSAGE_8:"Příčina: žádné spojení s elektronikou 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"Žádné připojení k elektronice čerpadla na mycí stanici 1",
    KARCHER_ERROR_MESSAGE_11:"Elektronické zásuvky na mycí stanici 1 jsou přetížené",
    KARCHER_ERROR_MESSAGE_12:"Příliš vysoký proud vysokotlakého čerpadla na mycí stanici 1",
    KARCHER_ERROR_MESSAGE_13:"Přílišnízký proud vysokotlakého čerpadla na mycí stanici 1",
    KARCHER_ERROR_MESSAGE_14:"Zaseknutý kontakt vysokotlakého čerpadla na mycí stanici 1",
    KARCHER_ERROR_MESSAGE_15:"Polozátěžový ventil na mycí stanici 1 vadný",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizace",
    CREATE_ORGANIZATION:"Vytvořit organizaci",
    CREATE_ORGANIZATION_AS:"Vytvořit jako dceřinou organizaci pro",
    DELETE_ORGANIZATION:"Smazat organizaci",
    EDIT_ORGANIZATION:"Upravit organizaci",
    SUPPORTED_ORG_NAME:"Podporovaná organizace",
    SUPPORTED_ORG_TYPE:"Podporovaný druh",
    ORG_NAME:"Jméno",
    ORG_TYPE:"Typ",
    SET_ORG_TITLE:"Nastavit podřízenou organizaci",
    SET_SUPPORTED_ORG_TITLE:"Nastavit podporu podřízené organizace",
    SAVE_ORGANIZATION:"Uložit organizaci",
    SELECT_ORGANIZATION_TYPE:"Vybrat druh organizace",
    SELECT_ORGANIZATION_SELECTOR:"Vybrat",
    SELECT_SUPPORTED_ORGANIZATION:"Vybrat podporovanou organizaci",
    ORGANIZATION_DELETED:"Organizace úspěšně odstraněna",
    ORGANIZATION_SAVED:"Organizace úspěšně uložena",
    ORGANIZATION_UPDATED:"Organizace byla úspěšně aktualizována",
    ALERTS:"Upozornění",
    DEVICE_STATUS:"Stav zařízení",
    SITE_DETAILS:"Podrobnosti sítě",
    ALARM_STATUS:"Stav upozornění",
    FILTER:"Filtrovat podle ...",
    FILTER_BY_ALERT_CENTER:"Filtrujte podle kódu, názvu nebo popisu",
    TOTAL_ALARM:"Celkem",
    LOW_ALARM:"Událost",
    MEDIUM_ALARM:"Porucha",
    HIGH_ALARM:"Kritická chyba",
    NO_FACILITIES_NEARBY:"V okolí se nenachází žádné zařízení",
    GRAY_MAP:"Šedá mapa",
    READY:"Připraven",
    WARNING:"Porucha",
    ERROR:"Chyba",
    SITE_NAME:"Název sítě",
    ACCOUNTS_INFO:"Informace o účtu",
    USER_ORGANIZATION:"Organizace uživatele",
    ADD_USER_ORGANIZATION:"Přidat nového firemního uživatele ",
    EDIT_USER_ORGANIZATION:"Upravte uživatele v organizaci",
    SELECT_ROLE:"Vybrat roli",
    SELECT_ORGANIZATION:"Vybrat organizaci",
    SELECT_USER:"Vybrat uživatele",
    USER_FOR_ORGANIZATION_CREATED:"Nový uživatel byl úspěšně vytvořen",
    SELECT_REGION:"Vyberte region",
    SELECT_LANGUAGE:"Vyberte jazyk",
    LOADING_DATA:"Načítání dat, čekejte prosím...",
    ADMINISTRATOR:"Administrátor",
    TECHNICAL_SUPPORT:"Technická podpora",
    CONTROLLER:"Kontrola",
    EDIT_ORGANIZATION_USER:"Upravte uživatele v organizaci",
    DELETE_ORGANIZATION_USER:"Smazat uživatele v organizaci",
    USER_UPDATED:"Uživatel byl úspěšně aktualizován",
    USER_CREATED:"Uživatel byl úspěšně vytvořen",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"odběry",
    RESOLVED_STATUS:"Vyřešeno",
    NOT_RESOLVED_STATUS:"Nevyřešeno",
    ALERT_NAME:"Název upozornění",
    ALERT_DESCRIPTION:"Popis upozornění",
    ALERT_CODE:"Kód upozornění ",
    ALERT_TYPE:"Typ upozornění",
    UNSUBSCRIBE:"Odhlásit upozornění",
    SUBSCRIBE:"Odebírat upozornění",
    ALARM_SUBSCRIBED:"Úspěšně přihlášeni k odběru",
    UNSUBSCRIBED_CONFIRM:"Odhlásit?",
    ALARM_UNSUBSCRIBED:"Úspěšně odhlášen",
    ASIDE_MENU_CASHLESS_SALES:"Bezhotovostní prodej",
    FILTERED_CASHLESS_PAYMENTS:"Filtrované bezhotovostní platby",
    REFUND_DIALOG_TITLE:"Vrácení transakce?",
    REFUND_DIALOG_SUBTITLE:"Hodnota může být menší nebo rovna částce transakce",
    REFUND:"Refundace",
    INPUT_NOT_VALID:"Zadaná hodnota není platná",
    REFUND_SUCCESSFULLY:"Vrácení vybrané platby proběhlo úspěšně",
    USER:"Uživatel",
    TRANSACTION_ID:"PSP reference",
    DEVICE_ID:"ID zařízení",
    NET_AMOUNT:"Netto částka",
    REPORT_NAME:"Název reportu",
    TIME_FRAME:"Časový rámec",
    SUB_POINT:"Vyberte dílčí bod",
    SUB_POINT_LIST_NOT_EXIST:"Pro zvolené mycí zařízení neexistuje seznam dílčích bodů",
    FACILITY_TYPE:"Typ zařízení",
    MACHINE_NAME:"Název stroje",
    WASH_FACILITY_DETAILS:"Podrobnosti o mycím zařízení",
    WASH_BAY_DETAILS:"Podrobnosti o mycím doku",
    DEVICES_INFO:"Seznam zařízení",
    OPERATION_TIME_INFO:"Provozní doba",
    OPERATION_TIME_VACUUM_INFO:"Provozní doba vysavačů",
    OPERATION_TIME_ILLUMINATION_INFO:"Provozní doba pro osvětlení",
    AVAILABLE_TITLE:"Dostupné",
    UNAVAILABLE_TITLE:"nedostupné",
    CURRENT_PROGRAM:"Současný program",
    CREDITS:"Kredity",
    DEVICE_NAME:"Název zařízení",
    ACTIVE_ALARMS:"Aktivní upozornění",
    ALL_DAY:"Celý den",
    OPERATING_TIME_WASH_FACILITY:"Systém samoobslužného mytí",
    OPERATING_TIME_VACUUMS:"Vysavače",
    OPERATING_TIME_ILLUMINATION:"Osvětlení",
    OPERATION_COUNTERS:"Počítadla operací",
    EDIT:"Upravit",
    WASHING_PROGRAMS:"Mycí programy",
    INFO:"Událost",
    STATISTIC:"Statistika",
    ROLLOVER_DOSING:"Dávkování",
    ROLLOVER_SPEED:"Rychlosti",
    ROLLOVER_RESETS:"Dálkový reset rolloveru",
    ROLLOVER_RESETS_INFO:"Vzdálené resetování musí být v souladu s místními předpisy. Důležité: Před resetováním se ujistěte, že rollover je prázdný.",
    RESET_ROLLOVER:"Resetovat rollover",
    OPEN_DOOR_ROLLOVER:"Otevřít",
    ROLLOVER_OPEN_DOOR_INFO:"Otevřete dveře mycí haly. Buďte opatrní.",
    ROLLOVER_OPEN_DOOR:"Otevřít dveře",
    APPLY_DOSING_CHANGES:"Použít změny dávkování",
    APPLY_SPEED_CHANGES:" Apply speed changes",
    ACTUATION_SUCCESS:"Použijte změny rychlosti",
    REMAINING_TIME:"Zbývající čas",
    OPEN_24H:"Otevřeno 24 hodin",
    CLOSE_24H:"Zavřeno 24 hodin",
    VALIDATION_OPERATION_TIME:"Formát není správný. Použijte hh:mm",
    ROLLOVER:" Rollover",
    UPDATE_WASHING_PROGRAM:"Aktualizace mycího programu",
    UPDATE_ACTUATORS:"Aktualizace pohonu",
    OPEN_ROLOVER_DOOR_TITLE:"Chcete otevřít dveře rolloveru?",
    OPEN_ROLOVER_DOOR_CONTENT:"Opravdu chcete otevřít dveře?",
    RESET_ROLOVER_TITLE:"Chcete resetovat rollover?",
    RESET_ROLOVER_CONTENT:"Jste si jistí, že chcete resetovat rollover?",
    G0:"{{brand === 'r2w' ? 'Dok 0' : 'Dok 1'}}",
    G1:"{{brand === 'r2w' ? 'Dok 1' : 'Dok 2'}}",
    G2:"{{brand === 'r2w' ? 'Dok 2' : 'Dok 3'}}",
    G3:"{{brand === 'r2w' ? 'Dok 3' : 'Dok 4'}}",
    G4:"{{brand === 'r2w' ? 'Dok 4' : 'Dok 5'}}",
    G5:"{{brand === 'r2w' ? 'Dok 5' : 'Dok 6'}}",
    G6:"{{brand === 'r2w' ? 'Dok 6' : 'Dok 7'}}",
    G7:"{{brand === 'r2w' ? 'Dok 7' : 'Dok 8'}}",
    G8:"{{brand === 'r2w' ? 'Dok 8' : 'Dok 9'}}",
    G9:"{{brand === 'r2w' ? 'Dok 9' : 'Dok 10'}}",
    G10:"{{brand === 'r2w' ? 'Dok 10' : 'Dok 11'}}",
    U0:"{{brand === 'r2w' ? 'Vysavač 0' : 'Vysavač 1'}}",
    U1:"{{brand === 'r2w' ? 'Vysavač 1' : 'Vysavač 2'}}",
    U2:"{{brand === 'r2w' ? 'Vysavač 2' : 'Vysavač 3'}}",
    U3:"{{brand === 'r2w' ? 'Vysavač 3' : 'Vysavač 4'}}",
    U4:"{{brand === 'r2w' ? 'Vysavač 4' : 'Vysavač 5'}}",
    U5:"{{brand === 'r2w' ? 'Vysavač 5' : 'Vysavač 6'}}",
    U6:"{{brand === 'r2w' ? 'Vysavač 6' : 'Vysavač 7'}}",
    U7:"{{brand === 'r2w' ? 'Vysavač 7' : 'Vysavač 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Zpráva centra upozornění vytvořená vybranou sítí z řídicího panelu",
    ALERT_CENTER_TITLE_BY_FACILITY:"Zpráva centra výstrah vytvořená vybraným zařízením z řídicího panelu",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Zpráva centra výstrah",
    ERROR_MESSAGE_403:"Nemáte oprávnění použít toto volání rozhraní API. Kód chyby: 403",
    LAST_ACTIVE_PROGRAM:"Aktivní program / Poslední aktivní program",
    PROGRAM_ID:"Číslo programu",
    PROGRAM_PRICE:"Cena programu",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Nutné doplnit",
    EMPTY_CHEMICAL_LEVEL:"Prázdný",
    CHEMICAL_LEVEL:"Indikace hladiny mycích prostředků (%)",
    ROLLOVER_STATUS:"Stav rolloveru",
    ROLLOVER_STATUS_CODE_0:"Mytí je momentálně mimo provoz",
    ROLLOVER_STATUS_CODE_1:"Mimo provozní dobu",
    ROLLOVER_STATUS_CODE_2:"Vstup do programu povolen",
    ROLLOVER_STATUS_CODE_3:"Umístěte své vozidlo",
    ROLLOVER_STATUS_CODE_4:"Vozidlo dopředu",
    ROLLOVER_STATUS_CODE_5:"Vozidlo dozadu",
    ROLLOVER_STATUS_CODE_6:"Zastavit vozidlo",
    ROLLOVER_STATUS_CODE_7:"Mytí aktivní",
    ROLLOVER_STATUS_CODE_8:"Mytí zastaveno",
    ROLLOVER_STATUS_CODE_9:"Mytí aktivní (tact) ",
    ROLLOVER_STATUS_CODE_10:"Vystupte směrem dozadu",
    ROLLOVER_STATUS_CODE_11:"Nouzové zastavení",
    ROLLOVER_STATUS_CODE_12:"Vystupte směrem dozadu",
    ROLLOVER_STATUS_CODE_13:"Aktivní protinámraza",
    ROLLOVER_STATUS_CODE_14:"Bezpečnostní spínač vpředu aktivován",
    ROLLOVER_STATUS_CODE_15:"Bezpečnostní spínač vzadu aktivován",
    ROLLOVER_STATUS_CODE_16:"Aktivován bezpečnostní spínač na levé přední straně",
    ROLLOVER_STATUS_CODE_17:"Aktivován bezpečnostní spínač na pravé přední straně",
    ROLLOVER_STATUS_CODE_18:"Aktivován bezpečnostní spínač na levé zadní straně",
    ROLLOVER_STATUS_CODE_19:"Aktivován bezpečnostní spínač na pravé zadní straně",
    ROLLOVER_STATUS_CODE_20:"Poloha vozidla příliš na levé straně",
    ROLLOVER_STATUS_CODE_21:"Poloha vozidla příliš na pravé straně",
    ROLLOVER_STATUS_CODE_22:"Levé dveře nejsou zavřené",
    ROLLOVER_STATUS_CODE_23:"Pravé dveře nejsou zavřené",
    ROLLOVER_STATUS_CODE_24:"Detekován přepravník, zvolen nesprávný mycí program",
    ROLLOVER_STATUS_CODE_25:"Senzor houkačky",
    ROLLOVER_STATUS_CODE_98:"Manuální / režim nastavení",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Kritická závada",
    NO_ALARM:"Žádná kritická závada",
    SOFTWARE_VERSION:"Verze softwaru",
    SOFTWARE_DATE:"Datum softwaru",
    SITE_ADDRESS:"Adresa místa",
    SECONDS:"Sekundy",
    SERVICE_PART_NAME:"Název služby",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Počítadlo operací a služeb",
    OPERATION_COUNTER:"Počítadlo operací",
    SERVICE_COUNTER:"Počítadlo služeb",
    FAULT_CODE:"Kód upozornění",
    PRESSURE_TITLE:"Tlak vzduchu",
    TIME_TITLE:"Aktuální čas",
    COUNTRY_TITLE:"Země",
    CITY_TITLE:"Město",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Vyberte body ...",
    LOGS_HISTORY:"Historie změn parametrů",
    ACTUATOR_REFERENCE:"Referenční číslo aktuátoru",
    ACTUATOR_VALUE:"Hodnota aktuátoru",
    POINT_ID:" ID bodu",
    VALIDATION_NOT_VALID_RANGE:"Nesprávný rozsah",
    ENABLE_ROLLOVER_RESET:"Zaškrtnutím tohoto políčka potvrzujete, že jste si přečetli a souhlasíte s bezpečnostními pokyny.",
    CHANGE_OF_PARAMETERS:"Změna parametrů",
    SELECT_OPTIONS:"Vyberte možnosti",
    AUTOMATIC:"Automatické",
    DESALTING:"Funkce odsolování",
    SEASON_WASH:"Sezónní mycí programy",
    SPRING_PROGRAM:"Jarní mycí programy",
    SUMMER_PROGRAM:"Letní mycí programy",
    AUTUMN_PROGRAM:"Podzimní mycí programy",
    WINTER_PROGRAM:"Zimní mycí programy",
    DOOR_CONTROL:"Ovládání dveří",
    SUMMER_DOOR_CONTROL:"Léto, ovládání brány v letním režimu",
    WINTER_DOOR_CONTROL:"Zima, ovládání brány v zimním režimu",
    APPLY_PARAMETERS_CHANGES:"Použít změny parametrů",
    WORKING_SCHEDULES:"Pracovní doba",
    HOLIDAY_SCHEDULES:"Rozvrhy dovolených",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Dovolená na webu byla úspěšně vytvořena",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Dovolená na webu byla úspěšně aktualizována",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Prázdniny na webu byly úspěšně smazány",
    WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"Plány pracovní doby na místě byly úspěšně aktualizovány",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Plán pracovní doby úspěšně rozšířen",
    HOLIDAY_SUCCESSFULLY_DELETED:"Dovolená úspěšně smazána",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:" SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:" SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:" SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:" SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:" SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:" SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:" SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:" SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:" SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:" SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:" SB_OB_2_0_0_Trans",
    CB3_1_0_0:" CB3_1_0_0_Trans",
    CW35_3_0_0:" CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:" CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:" CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Vysoušeč má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampón má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_FOAM:"Pěna má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_WAX_1:"Vosk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_POLISH_1:"Lesk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Čistič disků má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_WAX_2:"Vosk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Lesk pneumatk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Odstraňovač hmyzu má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_POLISH_2:"Lesk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensiv má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pěnový déšť má nízkou hladinu náplně",
    CHEM_LEVEL_DRYING_AGENT:"Úroveň náplně vysoušeč",
    CHEM_LEVEL_SHAMPOO:"Úroveň náplně šampón",
    CHEM_LEVEL_FOAM:"Úroveň náplně pěna",
    CHEM_LEVEL_WAX_1:"Úroveň náplně vosk",
    CHEM_LEVEL_POLISH_1:" Úroveň náplně lesk",
    CHEM_LEVEL_RIM_CLEANER:" Úroveň náplně čistič disků",
    CHEM_LEVEL_WAX_2:" Úroveň náplně vosk",
    CHEM_LEVEL_TYRE_SHINE:" Úroveň náplně lesk pneumatik",
    CHEM_LEVEL_INSECT_REMOVER:" Úroveň náplně odstraňovač hmyzu",
    CHEM_LEVEL_POLISH_2:" Úroveň náplně lesk",
    CHEM_LEVEL_INTENSIVE:" Úroveň náplně intenzivní",
    CHEM_LEVEL_FOAM_RAIN:" Úroveň náplně pěnový dešť",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servisní počítadlo na zvedací pás střešních kartáčů",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servisní počítadlo zvedací lišty sušičky",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servisní počítadlo motoru střešního kartáče ",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servisní počítadlo čerpadla čerstvé vody",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servisní počítadlo čerpadla použité vody",
    DRYING_AGENT:"Vysoušecí prostředek",
    FOAM_DRYING_AGENT:"Pěnový vysoušecí prostředek",
    SHAMPOO:"Šampón",
    FOAM:"Pěna",
    BRUSH_FOAM:"Čištění kartáčem",
    WAX_1:"Vosk",
    FOAM_WAX_1:"Pěnový vosk",
    POLISH_1:"lesk",
    RIM_CLEANING:"Čistič disků",
    WAX_2:"Vosk",
    FOAM_WAX_2:"Pěnový vosk",
    TYRE_SHINE:"Lesk pneumatik",
    INSECT_REMOVER:"Odstraňovač hmyzu",
    POLISH_2:"Lesk",
    INTENSIVE_BASIC:"Intenzivní základní",
    INTENSIVE_SIDE:"Intenzivní boční",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzivní střešní stříkací lišta",
    TAR_REMOVER:"Odstraňovač dehtu",
    UNDER_CHASSIS_CONVERSATION:"Konzervace podvozku",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionární přednástřikový oblouk",
    FOAM_RAIN:"Pěnový déšť",
    PRE_CLEANING:"Předmytí",
    BRUSH:"Kartáč",
    CARE:"Péče",
    DRYING:"Sušení",
    DRYING_LOW_NOISE:"Snížení hluku sušení",
    INTENSIVE_CLEANING:"Intenzivní čištění",
    BRUSH_CLEANING:"Čištění kartáčem",
    EMPTY_RUN:"Prázdný běh",
    DRYING_AID:"Vysoušeč",
    WAX:"Vosk",
    FOAM_WASH:"Mytí pěnou",
    POLISH:"Lesk",
    FOAM_POLISH:"Pěnové leštění",
    WHEEL_CLEANING:"Čištění kol",
    HIGH_PRESSURE_ROOF:"Střešní vysoký tlak",
    HIGH_PRESSURE_SIDE:"Boční vysoký tlak",
    DRYER_FORWARD:"Boční vysoký tlak",
    DRYER_BACKWARD:"Vysoušeč dopředu",
    DELETE_ALL_HOLIDAYS:"Smazat všechny svátky pro vybranou síť",
    CREATE_NEW_HOLIDAY:"Vytvořit nový",
    RESET_INPUTS:"Resetujte všechny svátky",
    TWENTY_FOUR_HOURS_OPEN:"Otevřeno 24 hodin",
    EVERY_YEAR:"Roční",
    DELETE_HOLIDAY:"Odstranit prázdniny",
    ADD_NEW_HOLIDAY:"Přidat nové prázdiny",
    HOLIDAYS_LIST:"Seznam existujících svátků",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Smazat všechny svátky pro vybranou síť?",
    VALIDATION_HOLIDAY_DATE:"Formát není správný. Použijte mm-dd",
    FOR_DATE:"Na datum",
    WITH_ID:"S ID",
    FROM_HOURS:"Od (h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:"Do (m)",
    NOT_MATCH:"Neshoduje se",
    START:"Od",
    STOP:"Do",
    DAILY_TIME:"24 hodinový seznam",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individuální nastavení času",
    PROGRAM_NOT_STARTED:"Program ještě nebyl spuštěn",
    JETWASH:"Systém samoobslužného mytí",
    KARCHER_REPORT_1:"Rollover: Indikace obratu dle programu a celkem",
    KARCHER_REPORT_2:"Rollover: Zahájené mytí dle programu a celkem",
    KARCHER_REPORT_3:"Rollover: Provedené mytí dle programu a celkem",
    KARCHER_REPORT_4:"Rollover: Množství zahájených mytí prostřednictvím platebního terminálu dle programu a celkem",
    KARCHER_REPORT_5:"Rollover: Počet ručně spuštěných mytí dle programu a celkem",
    KARCHER_REPORT_6:"Rollover: Počet zrušených mytí dle programu a celkem",
    KARCHER_REPORT_7:"Rollover: Počet výpadků napájení",
    KARCHER_REPORT_8:"Jednotky SB: Počet hodin dle mycího programu filtrovaný podle doku a celkem",
    KARCHER_REPORT_9:"Jednotky SB: Indikace obratu na mycí pozici a celkem",
    KARCHER_REPORT_10:"Jednotky SB: Počítadlo tokenů/mincí dle kanálu mincí",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Čerpadlo na čerstvou vodu",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Proces vodního čerpadla",
    OPERATION_COUNTER_HP_PUMP_1:"Vysokotlaké čerpadlo 1",
    OPERATION_COUNTER_HP_PUMP_2:"Vysokotlaké čerpadlo 2",
    RELEASE_NOTES:"Verze aplikace a poznámky k verzi",
    BACKEND_RELEASE_NOTES:"Poznámky k verzi platformy:",
    FRONTEND_RELEASE_NOTES:"Poznámky k verzi webové aplikace:",
    SELECTED_FACILITY_TIMEZONE:"Časové pásmo pro vybrané zařízení:",
    REFRESH_PAGE:"Obnovit stránku",
    REFRESH_MAPS:"Obnovit mapy",
    PUMPS:"čerpadla",
    RUN_TIME:"Doba chodu",
    RUN_TIME1:"Doba chodu 1",
    RUN_TIME2:"Doba chodu 2",
    PROGRAM_RUNTIME_ACTUATOR:"Regulátor doby chodu ",
    PROGRAM_RUNTIME_ACTUATOR_1:"Regulátor doby chodu 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Regulátor doby chodu 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimální hodnota je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maximální hodnota je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Použijte formát ceny x.xx",
    ACTUATION_NOT_ALLOWED:"Pro aktuální uživatelskou roli není povoleno ovládání",
    MAINTENANCE_DAYS:"Dny údržby",
    MAINTENANCE_WASHES:"Údržba myčky",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Celkový příjem POS",
    PROPAGATE:"Propagovat",
    ALL_DAY_HOURS_SELECTOR:"Volič typu na 24 hodin",
    GET_OPERATING_TIME_FROM_SITE:"Získejte provozní dobu pro aktuální zařízení z místního pracovního plánu",
    USER_NOT_VALID:"Uživatel není platný. Zkuste použít jiné přihlašovací údaje k účtu.",
    VERIFIED:"Ověřeno",
    RESEND_VERIFICATION_MAIL:"Opětovné zaslání ověřovacího e-mailu",
    RETURN_TO_DASHBOARD:"Vraťte se na ovládací panel",
    ERROR_PAGE_BAD_REQUEST:"400 špatný požadavek.",
    WASHES:"Počet mytí",
    TIME_TO_SERVICE:"Čas na servis",
    ACCOUNT_ALREADY_ACTIVATED:"Účet je již aktivován",
    DEVICE_EVENTS:"Události zařízení",
    DEVICE_EVENTS_LOG_PULLED:"Stažený log událostí pro zařízení",
    EVENTS_PULL_DATE:"Čas stažených událostí",
    DEVICE_EVENTS_REFRESH:"Stáhnout nová data událostí",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problém s připojením webových socketů. Zkuste obnovit stránku.",
    INSTALLATION_DATE:"Datum instalace zařízení",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Horký vosk",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Mytí vysokým tlakem",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Pěna na kola",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Pěna s vysokým výkonem",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Zastavit",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Mytí pěnou HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Mytí",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Vrcholná péče",
    INFO_TITLE:"Informace",
    FOAM_WAX1:"Pěnový vosk",
    POLISH1:"Lesk",
    WAX1:"Vosk",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Podrobnosti o místě byly úspěšně aktualizovány",
    COMPANY:"Společnost",
    FACILITY_HAS_CHANGER:"Máte měnič?",
    DISABLE_OFFLINE_ALARM:"Zakázat alarmy R2W",
    ASIDE_WORKING_SCHEDULES:"Podrobnosti o místě aplikace",
    TERMS_OF_SERVICE_R2W_TITLE:"Podmínky služby Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Podmínky služby Ready2Wash",
    DATA_PROCESSING_TITLE:"Zpracovaná data",
    PRIVACY_POLICY_TITLE:"Zásady ochrany osobních údajů",
    READY_TO_PAY_TERMS_OF_SERVICE:" Podmínky služby Ready2Pay",
    TERMS_AND_SERVICES:"Podmínky a služby",
    HOURLY: "Hodinově",
    DAILY: "Denně",
    WEEKLY: "Týdně",
    MONTHLY: "Měsíčně",
    YEARLY: "Ročně",
    DELETE_ITEM_SUCCESS:"Úspěšně jste smazali položku",
    STATE: "Stát",
    AVAILABILITY_STATUS_1: "Jednotka otevřená",
    AVAILABILITY_STATUS_2: "Jednotka zavřená (dovolená)",
    AVAILABILITY_STATUS_3: "Jednotka zavřená (provozní doba)",
    AVAILABILITY_STATUS_4: "Jednotka zavřená (porucha)",
    AVAILABILITY_STATUS_5: "Jednotka zavřená (ostatní)",
    AVAILABILITY_VACUUMS_STATUS_1: "Vysavače nenainstalované",
    AVAILABILITY_VACUUMS_STATUS_2: "Vysavače otevřené",
    AVAILABILITY_VACUUMS_STATUS_3: "Vysavače zavřené (dovolená)",
    AVAILABILITY_VACUUMS_STATUS_4: "Vysavače zavřené (provozní doba)",
    AVAILABILITY_VACUUMS_STATUS_5: "Vysavače zavřené (porucha)",
    AVAILABILITY_VACUUMS_STATUS_6: "Vysavače zavřené (ostatní)",
    ECOM_AMOUNT: "Celkový Ecom pro všechny lokality",
    CAPTURED: "Zachyceno",
    DELETE_COMPANY_HISTORY_INFO:"Tato akce odstraní všechna data zpráv vaší společnosti. Tuto akci nelze vrátit zpět.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Opravdu chcete natrvalo odstranit všechna data zpráv?",
    VALUE_DATE: "Datum hodnoty",
    KARCHER_EVENT_NAME_1: "Základní výměník obnoven",
    KARCHER_EVENT_NAME_2: "Regenerace základního výměníku ukončena",
    KARCHER_EVENT_NAME_3: "Materiál / sériové číslo",
    KARCHER_EVENT_NAME_4: "Systém byl dezinfikován",
    KARCHER_EVENT_NAME_5: "HP čerpadlo 1 bylo dezinfikováno",
    KARCHER_EVENT_NAME_6: "HP čerpadlo 2 bylo dezinfikováno",
    KARCHER_EVENT_NAME_7: "HP čerpadlo 3 bylo dezinfikováno",
    KARCHER_EVENT_NAME_8: "HP čerpadlo 4 bylo dezinfikováno",
    KARCHER_EVENT_NAME_9: "HP čerpadlo 5 bylo dezinfikováno",
    KARCHER_EVENT_NAME_10: "Mytí stanice 1 zamčeno",
    KARCHER_EVENT_NAME_11: "Mytí stanice 2 zamčeno",
    KARCHER_EVENT_NAME_12: "Mytí stanice 3 zamčeno",
    KARCHER_EVENT_NAME_13: "Mytí stanice 4 zamčeno",
    KARCHER_EVENT_NAME_14: "Mytí stanice 5 zamčeno",
    KARCHER_EVENT_NAME_15: "Mytí stanice 6 zamčeno",
    KARCHER_EVENT_NAME_16: "Mytí stanice 7 zamčeno",
    KARCHER_EVENT_NAME_17: "Mytí stanice 8 zamčeno",
    KARCHER_EVENT_NAME_18: "Aktualizace zahájena",
    KARCHER_EVENT_NAME_19: "Aktualizace dokončena",
    KARCHER_EVENT_NAME_20: "Spuštění WS Reg",
    KARCHER_EVENT_NAME_21: "Konec WS Reg",
    KARCHER_EVENT_NAME_22: "WS 75% senzor",
    KARCHER_EVENT_NAME_23: "Technická závada",
    KARCHER_EVENT_NAME_24: "Provozní závada",
    KARCHER_EVENT_NAME_25: "Jednotka zapnuta",
    KARCHER_EVENT_NAME_26: "Jednotka vypnuta",
    KARCHER_EVENT_NAME_27: "Box 1 zavřen",
    KARCHER_EVENT_NAME_28: "Box 2 zavřen",
    KARCHER_EVENT_NAME_29: "Box 3 zavřen",
    KARCHER_EVENT_NAME_30: "Box 4 zavřen",
    KARCHER_EVENT_NAME_31: "Box 5 zavřen",
    KARCHER_EVENT_NAME_32: "Box 6 zavřen",
    KARCHER_EVENT_NAME_33: "Box 7 zavřen",
    KARCHER_EVENT_NAME_34: "Box 8 zavřen",
    KARCHER_EVENT_NAME_35: "HP čerpadlová stanice 1",
    KARCHER_EVENT_NAME_36: "HP čerpadlová stanice 2",
    KARCHER_EVENT_NAME_37: "HP čerpadlová stanice 3",
    KARCHER_EVENT_NAME_38: "HP čerpadlová stanice 4",
    KARCHER_EVENT_NAME_39: "HP čerpadlová stanice 5",
    KARCHER_EVENT_NAME_40: "HP čerpadlová stanice 6",
    KARCHER_EVENT_NAME_41: "HP čerpadlová stanice 7",
    KARCHER_EVENT_NAME_42: "HP čerpadlová stanice 8",
    KARCHER_EVENT_NAME_43: "Hořák",
    KARCHER_EVENT_NAME_44: "Ventilátor hořáku",
    KARCHER_EVENT_NAME_45: "Čerpadlo teplé vody",
    KARCHER_EVENT_NAME_46: "Čerpadlo protimrazové ochrany",
    KARCHER_EVENT_NAME_47: "Osmotické čerpadlo",
    KARCHER_EVENT_NAME_48: "Podlahové vytápění",
    KARCHER_EVENT_NAME_49: "Ohřev hadice",
    KARCHER_EVENT_NAME_50: "Čištění mikro/prahu",
    KARCHER_EVENT_NAME_51: "Čerpadlo podvozku",
    KARCHER_EVENT_NAME_52: "Pěnové čerpadlo Booster",
    KARCHER_EVENT_NAME_53: "Vysavač 1",
    KARCHER_EVENT_NAME_54: "Vysavač 2",
    KARCHER_EVENT_NAME_55: "Vysavač 3",
    KARCHER_EVENT_NAME_56: "Vysavač 4",
    KARCHER_EVENT_NAME_57: "Vysavač 5",
    KARCHER_EVENT_NAME_58: "Vysavač 6",
    KARCHER_EVENT_NAME_59: "Vysavač 7",
    KARCHER_EVENT_NAME_60: "Vysavač 8",
    KARCHER_EVENT_NAME_61: "Vysavač 9",
    KARCHER_EVENT_NAME_62: "Vysavač 10",
    KARCHER_EVENT_NAME_63: "Vysavač 11",
    KARCHER_EVENT_NAME_64: "Vysavač 12",
    KARCHER_EVENT_NAME_65: "Čerpadlo prahů",
    KARCHER_EVENT_NAME_66: "Čerpadlo Microe.",
    KARCHER_EVENT_NAME_67: "Intenzivní čerpadlo",
    KARCHER_EVENT_NAME_68: "Turbína vysavače 1",
    KARCHER_EVENT_NAME_69: "Filtr vysavače 1",
    KARCHER_EVENT_NAME_70: "Turbína vysavače 2",
    KARCHER_EVENT_NAME_71: "Filtr vysavače 2",
    KARCHER_EVENT_NAME_72: "Turbína vysavače 3",
    KARCHER_EVENT_NAME_73: "Filtr vysavače 3",
    KARCHER_EVENT_NAME_74: "Turbína vysavače 4",
    KARCHER_EVENT_NAME_75: "Filtr vysavače 4",
    KARCHER_EVENT_NAME_76: "Turbína vysavače 5",
    KARCHER_EVENT_NAME_77: "Filtr vysavače 5",
    KARCHER_EVENT_NAME_78: "Turbína vysavače 6",
    KARCHER_EVENT_NAME_79: "Filtr vysavače 6",
    KARCHER_EVENT_NAME_80: "Turbína vysavače 7",
    KARCHER_EVENT_NAME_81: "Filtr vysavače 7",
    KARCHER_EVENT_NAME_82: "Turbína vysavače 8",
    KARCHER_EVENT_NAME_83: "Filtr vysavače 8",
    KARCHER_EVENT_NAME_84: "Turbína vysavače 9",
    KARCHER_EVENT_NAME_85: "Filtr vysavače 9",
    KARCHER_EVENT_NAME_86: "Turbína vysavače 10",
    KARCHER_EVENT_NAME_87: "Filtr vysavače 10",
    KARCHER_EVENT_NAME_88: "Turbína vysavače 11",
    KARCHER_EVENT_NAME_89: "Filtr vysavače 11",
    KARCHER_EVENT_NAME_90: "Turbína vysavače 12",
    KARCHER_EVENT_NAME_91: "Filtr vysavače 12",
    INSERT_TOKEN: "Vložte tokeny a spusťte službu",
    OPEN_SESSION: "Relace byla úspěšně otevřena",
    IN_PROGRESS: "Probíhá ...",
    TOKEN_INSERTED: "Tokeny byly úspěšně vloženy",
    EXPIRED_SESSION: "Relace vypršela",
    TWO_DIGIT_INTEGER_VALIDATION: "Použijte maximálně dvoumístné celé číslo",
    KARCHER_OPERATION_COUNTER_1: "Mytí stanice 1 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_2: "Mytí stanice 1 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_3: "Mytí stanice 1 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_4: "Mytí stanice 1 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_5: "Mytí stanice 1 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_6: "Mytí stanice 2 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_7: "Mytí stanice 2 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_8: "Mytí stanice 2 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_9: "Mytí stanice 2 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_10: "Mytí stanice 2 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_11: "Mytí stanice 3 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_12: "Mytí stanice 3 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_13: "Mytí stanice 3 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_14: "Mytí stanice 3 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_15: "Mytí stanice 3 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_16: "Mytí stanice 4 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_17: "Mytí stanice 4 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_18: "Mytí stanice 4 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_19: "Mytí stanice 4 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_20: "Mytí stanice 4 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_21: "Mytí stanice 5 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_22: "Mytí stanice 5 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_23: "Mytí stanice 5 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_24: "Mytí stanice 5 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_25: "Mytí stanice 5 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_26: "Mytí stanice 6 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_27: "Mytí stanice 6 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_28: "Mytí stanice 6 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_29: "Mytí stanice 6 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_30: "Mytí stanice 6 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_31: "Mytí stanice 7 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_32: "Mytí stanice 7 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_33: "Mytí stanice 7 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_34: "Mytí stanice 7 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_35: "Mytí stanice 7 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_36: "Mytí stanice 8 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_37: "Mytí stanice 8 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_38: "Mytí stanice 8 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_39: "Mytí stanice 8 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_40: "Mytí stanice 8 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_41: "Osmotické čerpadlo",
    KARCHER_OPERATION_COUNTER_42: "Generátor horké vody",
    KARCHER_OPERATION_COUNTER_43: "Čerpadlo na ochranu proti mrazu",
    KARCHER_OPERATION_COUNTER_44: "WSO filtr",
    KARCHER_OPERATION_COUNTER_45: "Čerpadlo vyhřívání mycí stanice",
    KARCHER_OPERATION_COUNTER_46: "Čerpadlo horké vody",
    KARCHER_OPERATION_COUNTER_47: "Vyhřívání hadice na pěnu",
    KARCHER_OPERATION_COUNTER_48: "Čerpadlo na mytí kol",
    KARCHER_OPERATION_COUNTER_49: "Mikro-emulzní čerpadlo",
    KARCHER_OPERATION_COUNTER_50: "Čerpadlo na intenzivní pěnu",
    KARCHER_OPERATION_COUNTER_51: "Vysavač 1 turbína 1",
    KARCHER_OPERATION_COUNTER_52: "Vysavač 1 filtr 1",
    KARCHER_OPERATION_COUNTER_53: "Vysavač 1 turbína 2",
    KARCHER_OPERATION_COUNTER_54: "Vysavač 1 filtr 2",
    KARCHER_OPERATION_COUNTER_55: "Vysavač 2 turbína 1",
    KARCHER_OPERATION_COUNTER_56: "Vysavač 2 filtr 1",
    KARCHER_OPERATION_COUNTER_57: "Vysavač 2 turbína 2",
    KARCHER_OPERATION_COUNTER_58: "Vysavač 2 filtr 2",
    KARCHER_OPERATION_COUNTER_59: "Vysavač 3 turbína 1",
    KARCHER_OPERATION_COUNTER_60: "Vysavač 3 filtr 1",
    KARCHER_OPERATION_COUNTER_61: "Vysavač 3 turbína 2",
    KARCHER_OPERATION_COUNTER_62: "Vysavač 3 filtr 2",
    KARCHER_OPERATION_COUNTER_63: "Vysavač 4 turbína 1",
    KARCHER_OPERATION_COUNTER_64: "Vysavač 4 filtr 1",
    KARCHER_OPERATION_COUNTER_65: "Vysavač 4 turbína 2",
    KARCHER_OPERATION_COUNTER_66: "Vysavač 4 filtr 2",
    KARCHER_OPERATION_COUNTER_67: "Vysavač 5 turbína 1",
    KARCHER_OPERATION_COUNTER_68: "Vysavač 5 filtr 1",
    KARCHER_OPERATION_COUNTER_69: "Vysavač 5 turbína 2",
    KARCHER_OPERATION_COUNTER_70: "Vysavač 5 filtr 2",
    KARCHER_OPERATION_COUNTER_71: "Vysavač 6 turbína 1",
    KARCHER_OPERATION_COUNTER_72: "Vysavač 6 filtr 1",
    KARCHER_OPERATION_COUNTER_73: "Vysavač 6 turbína 2",
    KARCHER_OPERATION_COUNTER_74: "Vysavač 6 filtr 2",
    KARCHER_OPERATION_COUNTER_75: "Odvod kondenzátu z kompresoru",
    KARCHER_OPERATION_COUNTER_76: "Zkontrolujte ochranu proti mrazu",
    KARCHER_OPERATION_COUNTER_77: "Ventilátor hořáku",
    KARCHER_OPERATION_COUNTER_78: "Posilovací čerpadlo pěny",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Seznam dat je větší než 10000 položek",
    KARCHER_POINT_NAME_1: "Svátek",
    KARCHER_POINT_NAME_2: "Pondělí",
    KARCHER_POINT_NAME_3: "Úterý",
    KARCHER_POINT_NAME_4: "Středa",
    KARCHER_POINT_NAME_5: "Čtvrtek",
    KARCHER_POINT_NAME_6: "Pátek",
    KARCHER_POINT_NAME_7: "Sobota",
    KARCHER_POINT_NAME_8: "Neděle",
    KARCHER_POINT_NAME_9: "Vysavače Svátek",
    KARCHER_POINT_NAME_10: "Vysavače Pondělí",
    KARCHER_POINT_NAME_11: "Vysavače Úterý",
    KARCHER_POINT_NAME_12: "Vysavače Středa",
    KARCHER_POINT_NAME_13: "Vysavače Čtvrtek",
    KARCHER_POINT_NAME_14: "Vysavače Pátek",
    KARCHER_POINT_NAME_15: "Vysavače Sobota",
    KARCHER_POINT_NAME_16: "Vysavače Neděle",
    KARCHER_POINT_NAME_17: "Osvětlení Svátek",
    KARCHER_POINT_NAME_18: "Osvětlení Pondělí",
    KARCHER_POINT_NAME_19: "Osvětlení Úterý",
    KARCHER_POINT_NAME_20: "Osvětlení Středa",
    KARCHER_POINT_NAME_21: "Osvětlení Čtvrtek",
    KARCHER_POINT_NAME_22: "Osvětlení Pátek",
    KARCHER_POINT_NAME_23: "Osvětlení Sobota",
    KARCHER_POINT_NAME_24: "Osvětlení Neděle",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR kód",
    ACCEPT_TERMS_AND_CONDITIONS: "Přijmout smluvní podmínky",
    CREATE_AND_PRINT_VOUCHERS: "Vytvořte a vytiskněte poukazy",
    CODE_PREFIX_QUESTION: "Předpona kódu není zadána",
    CODE_PREFIX_QUESTION_TEXT: "Chcete pokračovat bez předpony kódu?",
    ISSUED_DATE: "Datum vydání",
    VOUCHER_VALIDITY_DAYS: "Platnost poukazu (dny)",
    VALIDATION_ONLY_NUMBERS: "Jsou povolena pouze čísla",
    REPRINT_VOUCHERS: "Vytisknout kopii poukazů",
    EXPIRY_DATE: "Platí do",
    VOUCHER_TYPE_VACUUM: "Poukaz na: Vysavač",
    VOUCHER_TYPE_JETWASH: "Poukaz na: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Poukaz na: Matt"
  });
})();
